// ct-frontend/src/components/pages/in-context/SidebarNavigation/utils/colorUtils.js

export function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
export function srgbToLin(c) { c = c / 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
export function linToSrgb(c) { return c <= 0.0031308 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055; }

export function oklabToLinearRGB(L, a, b) {
    const l_ = L + 0.3963377774 * a + 0.2158037573 * b;
    const m_ = L - 0.1055613458 * a - 0.0638541728 * b;
    const s_ = L - 0.0894841775 * a - 1.2914855480 * b;
    const l = l_ * l_ * l_;
    const m = m_ * m_ * m_;
    const s = s_ * s_ * s_;
    const r = +4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s;
    const g = -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s;
    const b2 = -0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s;
    return [r, g, b2];
}

export function linearRGBToOklab(r, g, b) {
    const l = 0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b;
    const m = 0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b;
    const s = 0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b;
    const l_ = Math.cbrt(l), m_ = Math.cbrt(m), s_ = Math.cbrt(s);
    const L = 0.2104542553 * l_ + 0.7936177850 * m_ - 0.0040720468 * s_;
    const a = 1.9779984951 * l_ - 2.4285922050 * m_ + 0.4505937099 * s_;
    const b2 = 0.0259040371 * l_ + 0.7827717662 * m_ - 0.8086757660 * s_;
    return [L, a, b2];
}

export function oklchToHex(Lp, C, hDeg) {
    const L = Lp / 100; const h = (hDeg * Math.PI) / 180; const a = Math.cos(h) * C; const b = Math.sin(h) * C;
    const [rLin, gLin, bLin] = oklabToLinearRGB(L, a, b);
    const r = Math.round(clamp01(linToSrgb(rLin)) * 255);
    const g = Math.round(clamp01(linToSrgb(gLin)) * 255);
    const bl = Math.round(clamp01(linToSrgb(bLin)) * 255);
    const toHex2 = (v) => v.toString(16).padStart(2, "0");
    return `#${toHex2(r)}${toHex2(g)}${toHex2(bl)}`;
}

export function hexToOklch(hex) {
    const m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex || "");
    if (!m) return { L: 50, C: 0.1, h: 0 };
    const r = srgbToLin(parseInt(m[1], 16));
    const g = srgbToLin(parseInt(m[2], 16));
    const b = srgbToLin(parseInt(m[3], 16));
    const [L, a, bb] = linearRGBToOklab(r, g, b);
    const C = Math.sqrt(a * a + bb * bb);
    let h = (Math.atan2(bb, a) * 180) / Math.PI; if (h < 0) h += 360;
    return { L: L * 100, C, h };
}

export function formatOklch(L, C, h) {
    const Lp = L/100; const Cp = Math.max(0, C); const hp = (h % 360 + 360) % 360;
    return `oklch(${Lp.toFixed(3)} ${Cp.toFixed(4)} ${hp.toFixed(1)})`;
}

export function hexToHsl(hex) {
    // Remove the hash if present
    hex = hex.replace('#', '');
    
    // Parse the hex values
    const r = parseInt(hex.substr(0, 2), 16) / 255;
    const g = parseInt(hex.substr(2, 2), 16) / 255;
    const b = parseInt(hex.substr(4, 2), 16) / 255;
    
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const diff = max - min;
    
    // Calculate lightness
    const l = (max + min) / 2;
    
    let h, s;
    
    if (diff === 0) {
        h = s = 0; // achromatic
    } else {
        // Calculate saturation
        s = l > 0.5 ? diff / (2 - max - min) : diff / (max + min);
        
        // Calculate hue
        switch (max) {
            case r: h = (g - b) / diff + (g < b ? 6 : 0); break;
            case g: h = (b - r) / diff + 2; break;
            case b: h = (r - g) / diff + 4; break;
        }
        h /= 6;
    }
    
    // Convert to degrees and percentages
    h = Math.round(h * 360);
    s = Math.round(s * 100);
    const lPercent = Math.round(l * 100);
    
    return `hsl(${h} ${s}% ${lPercent}%)`;
}

export function toHex(color) {
    const ctx = document.createElement("canvas").getContext("2d");
    if (!ctx) return null;

    ctx.fillStyle = color;
    const computed = ctx.fillStyle;

    ctx.fillRect(0, 0, 1, 1);
    const { data } = ctx.getImageData(0, 0, 1, 1);

    const r = data[0].toString(16).padStart(2, "0");
    const g = data[1].toString(16).padStart(2, "0");
    const b = data[2].toString(16).padStart(2, "0");

    return `#${r}${g}${b}`;
}



// WEBPACK FOOTER //
// ./src/components/pages/in-context/SidebarNavigation/utils/colorUtils.js